import React, { useState } from "react";
import "./CreateSeat.css"; 
import { apiService } from "./services/apiService";

const Field = ({ label, required, children }) => (
  <div className="cs-field">
    <label className="cs-label">
      {label}{required && <span className="cs-required"> *</span>}
    </label>
    {children}
  </div>
);

function CreateSeat({ onSuccess, onBack }) {
  const initialForm = {
    seatCode: "",
    floor: "0",
    section: "",
    maxCapacity: "1",
    layoutSection: ""
  };

  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!form.seatCode.trim()) return "Seat Code is required";
    if (isNaN(form.floor) || form.floor.trim() === "") return "Floor number must be valid";
    if (Number(form.maxCapacity) < 1) return "Max Capacity must be at least 1";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const error = validateForm();
    if (error) { alert("⚠️ " + error); return; }

    setLoading(true);
    try {
      await apiService.createSeat({
        seatCode: form.seatCode.trim().toUpperCase(),
        floor: parseInt(form.floor, 10),
        section: form.section.trim(),
        maxCapacity: parseInt(form.maxCapacity, 10),
        layoutSection: form.layoutSection.trim()
      });

      alert("✅ Seat Created Successfully!");
      setForm(initialForm);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      alert("❌ Error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cs-page">
      <div className="cs-form-card">
        {/* Header */}
        <div className="cs-form-header">
          <div className="cs-header-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.2">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
            </svg>
          </div>
          <div>
            <h2 className="cs-form-title">Create New Seat</h2>
            <p className="cs-form-subtitle">Register a new seat layout in your library floor plan</p>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="cs-section">
            <div className="cs-section-label">
              <span className="cs-section-dot"></span>
              Seat Configuration
            </div>

            <div className="cs-grid-2">
              <Field label="Seat Code" required>
                <input 
                  className="cs-input" 
                  name="seatCode"
                  placeholder="e.g. A-12, B-01"
                  value={form.seatCode} 
                  onChange={handleChange} 
                />
              </Field>

              <Field label="Floor Number" required>
                <input 
                  className="cs-input" 
                  type="number" 
                  name="floor"
                  placeholder="0"
                  value={form.floor} 
                  onChange={handleChange} 
                />
              </Field>
            </div>

            <div className="cs-grid-2">
              <Field label="Section / Hall">
                <input 
                  className="cs-input" 
                  name="section"
                  placeholder="e.g. Quiet Zone, Reading Hall"
                  value={form.section} 
                  onChange={handleChange} 
                />
              </Field>

              <Field label="Max Capacity" required>
                <input 
                  className="cs-input" 
                  type="number" 
                  name="maxCapacity"
                  min="1"
                  placeholder="1"
                  value={form.maxCapacity} 
                  onChange={handleChange} 
                />
              </Field>
            </div>

            <Field label="Layout Section (Optional)">
              <input 
                className="cs-input" 
                name="layoutSection"
                placeholder="e.g. Section-A, Row-3"
                value={form.layoutSection} 
                onChange={handleChange} 
              />
            </Field>
          </div>

          {/* Form Action Buttons */}
          <div className="cs-actions">
            <button type="button" className="cs-btn cs-btn-back" onClick={onBack}>
              Cancel
            </button>
            <button type="submit" className="cs-btn cs-btn-submit" disabled={loading}>
              {loading ? "Creating..." : "Save Seat"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateSeat;